module.exports = __webpack_public_path__ + "media/male_resultD.1171b24b.mp3";